// extracted by mini-css-extract-plugin
module.exports = {"separator":"styles_separator__1XbTi"};